import React, { Component } from 'react';
import PromoHeaderComponent from './PromoHeaderComponent';

class PromoHeader extends Component {
  render() {
    const { image, imageOverlay, title, subtitle, tagline, buttonLabel, hashLinkTo, onClickButton, styles } =
      this.props;

    return (
      <PromoHeaderComponent
        image={image}
        imageOverlay={imageOverlay}
        title={title}
        subtitle={subtitle}
        tagline={tagline}
        buttonLabel={buttonLabel}
        hashLinkTo={hashLinkTo}
        onClickButton={onClickButton}
        styles={styles}
      />
    );
  }
}

export default PromoHeader;
